module.exports = __webpack_public_path__ + "img/avatar-6.6b610cc1.png";